export enum UgcTab {
  UgcTypeCostume = 1, // 服装设计
  UgcTypeMyROMemory = 4, // 我的RO记忆
  UgcTypePhoto = 5, // 美照分享
  UgcTypeMyPoring = 6, // 我的波利
  UgcTypeJobShare = 7, // 职业分享
}

export enum TaskCallbackId {
  JoinFb = 1,
  JoinDc = 2,
  JoinLine = 3,
  JoinYtb = 4,
  GameReservation = 5,
  GameDownload = 6,
}
